import { render, staticRenderFns } from "./associate-product.vue?vue&type=template&id=71c8e2b4&"
import script from "./associate-product.vue?vue&type=script&lang=js&"
export * from "./associate-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "associate-product.vue"
export default component.exports